import type { ReactNode, Ref } from 'react';
import { discoveryStyles as s } from './DiscoveryLayout';

/** One title/action row on every discovery page; optional copy is a separate row. */
export function DiscoveryHeader({
  title,
  subtitle,
  actions,
  ref,
}: {
  title: string;
  subtitle?: ReactNode;
  actions: ReactNode;
  ref?: Ref<HTMLElement>;
}) {
  return (
    <header ref={ref} className={s.header}>
      <h1 className={s.heading}>{title}</h1>
      <div className={s.actions}>{actions}</div>
      {subtitle && <p className={s.headerSubtitle}>{subtitle}</p>}
    </header>
  );
}
